import React, { useState } from "react";
import DynamicTextField from "../../../../Common/Textfield/Textfield";
import Button from "../../../../Common/Button/Button.js";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar";
import "./CandidateAcademicsEdit.css";
import CustomTooltip from "../../../../Common/Tooltip/Tooltip.js";

function AcademicsEducationDetailsEdit({
  candidate,
  editedCandidateData,
  handleCandidateChange,
}) {
  const [newCert, setNewCert] = useState({
    Degree: "",
    FieldOfStudy: "",
    Institute: "",
    InstituteLocationCity: "",
    InstituteLocationCountry: "",
    GraduationDate: "",
  });
  const inputStyle = {
    width: "100%",
    color: "var(--header__color)",
    background: "none",
    border: "1px solid var(--accordian-border)",
    borderRadius: "12px",
  };
  const educationDetails =
    editedCandidateData.EducationHistory !== undefined
      ? Array.isArray(editedCandidateData.EducationHistory)
        ? editedCandidateData.EducationHistory
        : []
      : candidate?.parsedResumeData?.EducationHistory || [];

  const handleFieldChange = (index, field, value) => {
    const updatedCerts = [...educationDetails];
    updatedCerts[index] = { ...updatedCerts[index], [field]: value };
    handleCandidateChange({ EducationHistory: updatedCerts });
  };
  const handleRemove = (index) => {
    const updatedCerts = educationDetails.filter((_, i) => i !== index);
    handleCandidateChange({ EducationHistory: updatedCerts });
  };
  const handleAdd = () => {
    if (
      !newCert.Degree?.trim() ||
      !newCert.FieldOfStudy?.trim() ||
      !newCert.Institute?.trim()
    ) {
      Toast("error", "Education Details are required.");
      return;
    }
    const updatedCerts = [...educationDetails, newCert];
    handleCandidateChange({ EducationHistory: updatedCerts });
    setNewCert({
      Degree: "",
      FieldOfStudy: "",
      Institute: "",
      InstituteLocationCity: "",
      InstituteLocationCountry: "",
      GraduationDate: "",
    });
  };
  return (
    <div>
      {educationDetails.map((cert, index) => (
        <div
          style={{
            border: "1px solid var(--accordian-border)",
            borderRadius: "12px",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          <div className="delete-icon-container">
            <CustomTooltip title={"Delete this education details."}>
              <HighlightOffIcon
                onClick={() => handleRemove(index)}
                style={{ fontSize: "25px", cursor: "pointer" }}
              />
            </CustomTooltip>
          </div>
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
            }}
          >
            <DynamicTextField
              label="Degree"
              name="degree"
              placeholder="Enter degree"
              style={inputStyle}
              labelStyle={{
                color: "var(--text-color-accent)",
                fontSize: "14px",
                fontWeight: 500,
              }}
              value={cert.Degree || ""}
              onChange={(e) =>
                handleFieldChange(index, "Degree", e.target.value)
              }
              required={true}
            />
            <DynamicTextField
              label="Field of Study"
              name="FieldOfStudy"
              placeholder="Enter field of study"
              style={inputStyle}
              labelStyle={{
                color: "var(--text-color-accent)",
                fontSize: "14px",
                fontWeight: 500,
              }}
              value={cert.FieldOfStudy || ""}
              onChange={(e) =>
                handleFieldChange(index, "FieldOfStudy", e.target.value)
              }
              required={true}
            />
            <DynamicTextField
              label="Institute"
              name="Institute"
              placeholder="Enter institute"
              style={inputStyle}
              labelStyle={{
                color: "var(--text-color-accent)",
                fontSize: "14px",
                fontWeight: 500,
              }}
              value={cert.Institute || ""}
              onChange={(e) =>
                handleFieldChange(index, "Institute", e.target.value)
              }
              required={true}
            />
            <DynamicTextField
              label="Institute Location City"
              name="InstituteLocationCity"
              placeholder="Enter institute location city"
              style={inputStyle}
              labelStyle={{
                color: "var(--text-color-accent)",
                fontSize: "14px",
                fontWeight: 500,
              }}
              value={cert.InstituteLocationCity || ""}
              onChange={(e) =>
                handleFieldChange(
                  index,
                  "InstituteLocationCity",
                  e.target.value,
                )
              }
            />
            <DynamicTextField
              label="Institute Location Country"
              name="InstituteLocationCountry"
              placeholder="Enter institute location country"
              style={inputStyle}
              labelStyle={{
                color: "var(--text-color-accent)",
                fontSize: "14px",
                fontWeight: 500,
              }}
              value={cert.InstituteLocationCountry || ""}
              onChange={(e) =>
                handleFieldChange(
                  index,
                  "InstituteLocationCountry",
                  e.target.value,
                )
              }
            />
            <DynamicTextField
              label="Graduation Date"
              name="GraduationDate"
              placeholder="Enter graduation date"
              style={inputStyle}
              labelStyle={{
                color: "var(--text-color-accent)",
                fontSize: "14px",
                fontWeight: 500,
              }}
              value={cert.GraduationDate || ""}
              onChange={(e) =>
                handleFieldChange(index, "GraduationDate", e.target.value)
              }
            />
          </div>
        </div>
      ))}
      <div className="cert-add-container">
        <div className="cert-add-header">
          <span className="cert-add-header-icon">＋</span>
          <span className="cert-add-header-title">
            Add New Education Details
          </span>
        </div>
        <div className="cert-add-career-fields">
          <DynamicTextField
            label="Degree"
            name="degree"
            placeholder="Enter degree"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.Degree}
            onChange={(e) => setNewCert({ ...newCert, Degree: e.target.value })}
            required={true}
          />
          <DynamicTextField
            label="Field of Study"
            name="FieldOfStudy"
            placeholder="Enter field of study"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.FieldOfStudy}
            onChange={(e) =>
              setNewCert({ ...newCert, FieldOfStudy: e.target.value })
            }
            required={true}
          />
          <DynamicTextField
            label="Institute"
            name="Institute"
            placeholder="Enter institute"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.Institute}
            onChange={(e) =>
              setNewCert({ ...newCert, Institute: e.target.value })
            }
            required={true}
          />
          <DynamicTextField
            label="Institute Location City"
            name="InstituteLocationCity"
            placeholder="Enter institute location city"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.InstituteLocationCity}
            onChange={(e) =>
              setNewCert({ ...newCert, InstituteLocationCity: e.target.value })
            }
          />
          <DynamicTextField
            label="Institute Location Country"
            name="InstituteLocationCountry"
            placeholder="Enter institute location country"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.InstituteLocationCountry}
            onChange={(e) =>
              setNewCert({
                ...newCert,
                InstituteLocationCountry: e.target.value,
              })
            }
          />
          <DynamicTextField
            label="Graduation Date"
            name="GraduationDate"
            placeholder="Enter graduation date"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.GraduationDate}
            onChange={(e) =>
              setNewCert({ ...newCert, GraduationDate: e.target.value })
            }
          />
        </div>
        <div className="cert-add-career-btn-wrapper">
          <Button label="Add Education" event={handleAdd} />
        </div>
      </div>
    </div>
  );
}

function AcademicsCertificationEdit({
  candidate,
  editedCandidateData,
  handleCandidateChange,
}) {
  const [newCert, setNewCert] = useState({
    CertificationName: "",
    IssuingOrganization: "",
    IssueDate: "",
  });

  const certifications =
    editedCandidateData?.CertificationsAndLicenses !== undefined
      ? Array.isArray(editedCandidateData.CertificationsAndLicenses)
        ? editedCandidateData.CertificationsAndLicenses
        : []
      : candidate?.parsedResumeData?.CertificationsAndLicenses || [];

  const handleFieldChange = (index, field, value) => {
    const updatedCerts = [...certifications];
    updatedCerts[index] = { ...updatedCerts[index], [field]: value };
    handleCandidateChange({ CertificationsAndLicenses: updatedCerts });
  };

  const handleRemove = (index) => {
    const updatedCerts = certifications.filter((_, i) => i !== index);
    handleCandidateChange({ CertificationsAndLicenses: updatedCerts });
  };

  const handleAdd = () => {
    if (!newCert.CertificationName?.trim()) {
      Toast("error", "Certification Name is required.");
      return;
    }
    const updatedCerts = [...certifications, newCert];
    handleCandidateChange({ CertificationsAndLicenses: updatedCerts });
    setNewCert({
      CertificationName: "",
      IssuingOrganization: "",
      IssueDate: "",
    });
  };

  const inputStyle = {
    width: "100%",
    color: "var(--header__color)",
    background: "none",
    border: "1px solid var(--accordian-border)",
    borderRadius: "12px",
  };
  return (
    <div>
      {certifications.map((cert, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "10px",
            border: "1px solid var(--accordian-border)",
            borderRadius: "12px",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          <DynamicTextField
            label="Certification Name"
            name="CertificationName"
            placeholder="Enter certification name"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={cert.CertificationName || ""}
            onChange={(e) =>
              handleFieldChange(index, "CertificationName", e.target.value)
            }
            required={true}
          />
          <DynamicTextField
            label="Issuing Organization"
            name="IssuingOrganization"
            placeholder="Enter issuing organization"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={cert.IssuingOrganization || ""}
            onChange={(e) =>
              handleFieldChange(index, "IssuingOrganization", e.target.value)
            }
          />
          <DynamicTextField
            label="Issue Date"
            name="IssueDate"
            placeholder="Enter issue date"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={cert.IssueDate || ""}
            onChange={(e) =>
              handleFieldChange(index, "IssueDate", e.target.value)
            }
          />
          <div className="delete-icon-container">
            <CustomTooltip title={"Delete this certification details."}>
              <HighlightOffIcon
                onClick={() => handleRemove(index)}
                style={{ fontSize: "25px", cursor: "pointer" }}
              />
            </CustomTooltip>
          </div>
        </div>
      ))}
      <div className="cert-add-container">
        <div className="cert-add-header">
          <span className="cert-add-header-icon">＋</span>
          <span className="cert-add-header-title">Add New Certification</span>
        </div>
        <div className="cert-add-fields">
          <DynamicTextField
            label="Certification Name"
            name="CertificationName"
            placeholder="Enter certification name"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.CertificationName}
            onChange={(e) =>
              setNewCert({ ...newCert, CertificationName: e.target.value })
            }
            required={true}
          />
          <DynamicTextField
            label="Issuing Organization"
            name="IssuingOrganization"
            placeholder="Enter issuing organization"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.IssuingOrganization}
            onChange={(e) =>
              setNewCert({ ...newCert, IssuingOrganization: e.target.value })
            }
          />
          <DynamicTextField
            label="Issue Date"
            name="IssueDate"
            placeholder="Enter issue date"
            style={inputStyle}
            labelStyle={{
              color: "var(--text-color-accent)",
              fontSize: "14px",
              fontWeight: 500,
            }}
            value={newCert.IssueDate}
            onChange={(e) =>
              setNewCert({ ...newCert, IssueDate: e.target.value })
            }
          />
          <div className="cert-add-btn-wrapper">
            <Button label="Add Certification" event={handleAdd} />
          </div>
        </div>
      </div>
    </div>
  );
}

function CareerInfoEdit({
  candidate,
  editedCandidateData,
  handleCandidateChange,
}) {
  const [newCareer, setNewCareer] = useState({
    JobTitle: "",
    JobCompany: "",
    JobLocationCity: "",
    JobLocationCountry: "",
    StartDate: "",
    EndDate: "",
  });

  const careerInfo =
    editedCandidateData?.CareerHistory?.JobDetails !== undefined
      ? Array.isArray(editedCandidateData.CareerHistory?.JobDetails)
        ? editedCandidateData.CareerHistory?.JobDetails
        : []
      : candidate?.parsedResumeData?.CareerHistory?.JobDetails || [];

  const handleFieldChange = (index, field, value) => {
    const updatedJobs = [...careerInfo];
    updatedJobs[index] = { ...updatedJobs[index], [field]: value };
    handleCandidateChange({
      CareerHistory: {
        ...(editedCandidateData?.CareerHistory ||
          candidate?.parsedResumeData?.CareerHistory ||
          {}),
        JobDetails: updatedJobs,
      },
    });
  };

  const handleRemove = (index) => {
    const updatedJobs = careerInfo.filter((_, i) => i !== index);
    handleCandidateChange({
      CareerHistory: {
        ...(editedCandidateData?.CareerHistory ||
          candidate?.parsedResumeData?.CareerHistory ||
          {}),
        JobDetails: updatedJobs,
      },
    });
  };

  const handleAdd = () => {
    if (!newCareer.JobTitle?.trim() || !newCareer.JobCompany?.trim()) {
      Toast("error", "Job Title and Job Company are required.");
      return;
    }
    const updatedJobs = [...careerInfo, newCareer];
    handleCandidateChange({
      CareerHistory: {
        ...(editedCandidateData?.CareerHistory ||
          candidate?.parsedResumeData?.CareerHistory ||
          {}),
        JobDetails: updatedJobs,
      },
    });
    setNewCareer({
      JobTitle: "",
      JobCompany: "",
      JobLocationCity: "",
      JobLocationCountry: "",
      StartDate: "",
      EndDate: "",
    });
  };

  const inputStyle = {
    width: "100%",
    color: "var(--header__color)",
    background: "none",
    border: "1px solid var(--accordian-border)",
    borderRadius: "12px",
  };

  const labelStyle = {
    color: "var(--text-color-accent)",
    fontSize: "14px",
    fontWeight: 500,
  };

  return (
    <div>
      {careerInfo.map((job, index) => (
        <div
          style={{
            border: "1px solid var(--accordian-border)",
            borderRadius: "12px",
            padding: "10px",
            marginBottom: "10px",
          }}
        >
          <div className="delete-icon-container">
            <CustomTooltip title={"Delete this career details."}>
              <HighlightOffIcon
                onClick={() => handleRemove(index)}
                style={{ fontSize: "25px", cursor: "pointer" }}
              />
            </CustomTooltip>
          </div>
          <div
            key={index}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
            }}
          >
            <DynamicTextField
              label="Job Title"
              name="JobTitle"
              placeholder="Enter job title"
              style={inputStyle}
              labelStyle={labelStyle}
              value={job.JobTitle || ""}
              onChange={(e) =>
                handleFieldChange(index, "JobTitle", e.target.value)
              }
              required={true}
            />
            <DynamicTextField
              label="Job Company"
              name="JobCompany"
              placeholder="Enter job company"
              style={inputStyle}
              labelStyle={labelStyle}
              value={job.JobCompany || ""}
              onChange={(e) =>
                handleFieldChange(index, "JobCompany", e.target.value)
              }
              required={true}
            />
            <DynamicTextField
              label="Job Location City"
              name="JobLocationCity"
              placeholder="Enter job location city"
              style={inputStyle}
              labelStyle={labelStyle}
              value={job.JobLocationCity || ""}
              onChange={(e) =>
                handleFieldChange(index, "JobLocationCity", e.target.value)
              }
            />
            <DynamicTextField
              label="Job Location Country"
              name="JobLocationCountry"
              placeholder="Enter job location country"
              style={inputStyle}
              labelStyle={labelStyle}
              value={job.JobLocationCountry || ""}
              onChange={(e) =>
                handleFieldChange(index, "JobLocationCountry", e.target.value)
              }
            />
            <DynamicTextField
              label="Start Date"
              name="StartDate"
              placeholder="Enter start date"
              style={inputStyle}
              labelStyle={labelStyle}
              value={job.StartDate || ""}
              onChange={(e) =>
                handleFieldChange(index, "StartDate", e.target.value)
              }
            />
            <DynamicTextField
              label="End Date"
              name="EndDate"
              placeholder="Enter end date"
              style={inputStyle}
              labelStyle={labelStyle}
              value={job.EndDate || ""}
              onChange={(e) =>
                handleFieldChange(index, "EndDate", e.target.value)
              }
            />
          </div>
        </div>
      ))}
      <div className="cert-add-container">
        <div className="cert-add-header">
          <span className="cert-add-header-icon">＋</span>
          <span className="cert-add-header-title">Add New Career</span>
        </div>
        <div className="cert-add-career-fields">
          <DynamicTextField
            label="Job Title"
            name="JobTitle"
            placeholder="Enter job title"
            style={inputStyle}
            labelStyle={labelStyle}
            value={newCareer.JobTitle}
            onChange={(e) =>
              setNewCareer({ ...newCareer, JobTitle: e.target.value })
            }
            required={true}
          />
          <DynamicTextField
            label="Job Company"
            name="JobCompany"
            placeholder="Enter job company"
            style={inputStyle}
            labelStyle={labelStyle}
            value={newCareer.JobCompany}
            onChange={(e) =>
              setNewCareer({ ...newCareer, JobCompany: e.target.value })
            }
            required={true}
          />
          <DynamicTextField
            label="Job Location City"
            name="JobLocationCity"
            placeholder="Enter job location city"
            style={inputStyle}
            labelStyle={labelStyle}
            value={newCareer.JobLocationCity}
            onChange={(e) =>
              setNewCareer({ ...newCareer, JobLocationCity: e.target.value })
            }
          />
          <DynamicTextField
            label="Job Location Country"
            name="JobLocationCountry"
            placeholder="Enter job location country"
            style={inputStyle}
            labelStyle={labelStyle}
            value={newCareer.JobLocationCountry}
            onChange={(e) =>
              setNewCareer({ ...newCareer, JobLocationCountry: e.target.value })
            }
          />
          <DynamicTextField
            label="Start Date"
            name="StartDate"
            placeholder="Enter start date"
            style={inputStyle}
            labelStyle={labelStyle}
            value={newCareer.StartDate}
            onChange={(e) =>
              setNewCareer({ ...newCareer, StartDate: e.target.value })
            }
          />
          <DynamicTextField
            label="End Date"
            name="EndDate"
            placeholder="Enter end date"
            style={inputStyle}
            labelStyle={labelStyle}
            value={newCareer.EndDate}
            onChange={(e) =>
              setNewCareer({ ...newCareer, EndDate: e.target.value })
            }
          />
        </div>
        <div className="cert-add-career-btn-wrapper">
          <Button label="Add Career" event={handleAdd} />
        </div>
      </div>
    </div>
  );
}

export { AcademicsEducationDetailsEdit, CareerInfoEdit };
export default AcademicsCertificationEdit;
